import { QueryClient } from "@tanstack/react-query";
import { LoaderFunctionArgs } from "react-router-dom";

import {
  assertAdminRole,
  userInfoQuery as userInfoQueryFn,
} from "@/features/shared/features/authentication";
import {
  dashboardQuery as dashboardQueryFn,
  dashboardsQuery as dashboardsQueryFn,
} from "@/features/shared/hooks";
import { ReturnTypeFromAsyncLoader } from "@/types/return-type-from-async-loader";

export const dashboardLoaderId = "admin-dashboard";

export const dashboardsLoader = (queryClient: QueryClient) => async () => {
  const userInfo = await queryClient.ensureQueryData(userInfoQueryFn());

  assertAdminRole(userInfo.roles ?? []);

  await queryClient.ensureQueryData(dashboardsQueryFn());

  return null;
};

export type dashboardsLoaderData = ReturnTypeFromAsyncLoader<typeof dashboardsLoader>;

export const dashboardLoader =
  (queryClient: QueryClient) =>
  async ({ params }: LoaderFunctionArgs) => {
    const userInfo = await queryClient.ensureQueryData(userInfoQueryFn());

    assertAdminRole(userInfo.roles ?? []);

    await queryClient.ensureQueryData(dashboardQueryFn(String(params.dashboard)));

    return null;
  };
